import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
// tslint:disable-next-line: no-use-before-declare
import NfcStickerTypeEnum = Open360NfcStickersAbstractionsFiltersNfcStickerRequest.NfcStickerTypeEnum;
import moment = require('moment');
import * as _ from 'underscore';
import { NotificationService } from '../../../../app.common/modules/common/services/notification.service';
import { NfcSticker, NfcStickerRequest } from '../../core';
import { Open360NfcStickersAbstractionsFiltersNfcStickerRequest } from '../../model/open360NfcStickersAbstractionsFiltersNfcStickerRequest';
import { NfcRetailerStickersService } from '../nfc-retailer-stickers.service';

class NfcRetailerActiveTab {
    public static $inject = ['$scope', '$translate', 'nfcRetailerStickersService', 'notificationService'];

    public waiting: boolean;
    public total: number;
    public items: NfcSticker[] = [];

    public search = {
        text: '' as string
    };

    public emptyStickerMessage: string;
    public emptyStickerMessageTitle: string;

    public filter= {
        isActive: false as boolean,
        isApplied: false as boolean,
        data: {
            selectedLocations: [] as any[],
            type: null as number,
            dateFrom: null as Date,
            dateTo: null as Date
        },
        clear: () => {
            this.filter.isApplied = false;
            this.filter.data = {
                selectedLocations: [],
                type: null,
                dateFrom: null,
                dateTo: null
            };
        },
        toggle: () => {
            this.filter.isActive = !this.filter.isActive;
            if (!this.filter.isActive) {
                this.clearFilter();
            }
        },
        set: (newFilterSettings: any) => {
            this.filter.isApplied = true;
            this.filter.data = {
                selectedLocations: newFilterSettings.selectedLocations,
                type: newFilterSettings.stickerType,
                dateFrom: newFilterSettings.dateFrom,
                dateTo: newFilterSettings.dateTo
            };
        }
    };

    public itemsLimit: number = 20;
    public freeStickersCount: number = 0;
    public canLoadMore: boolean = true;

    public stickerTypes: any = {
        1: this.$translate.instant('sticker_type_product'),
        2: this.$translate.instant('sticker_type_information_card'),
        3: this.$translate.instant('sticker_type_offer'),
        4: this.$translate.instant('sticker_type_checkout'),
        5: this.$translate.instant('sticker_type_checkin'),
    };

    public viewport = {
        width: $(window).width(),
        height: $(window).height(),
        scrollTop: 0
    };

    constructor(
        public $scope: ng.IScope,
        protected $translate: angular.translate.ITranslateService,
        public nfcRetailerStickersService: NfcRetailerStickersService,
        public notificationService: NotificationService
    ) {
    }

    public $onInit() {
        this.loadData();
        $(window).resize(() => {
            this.viewport.width = $(window).width();
            this.viewport.height = $(window).height();
            this.$scope.$apply();
        });

        $(window).scroll(() => {
            this.viewport.scrollTop = $(document).scrollTop();
            this.$scope.$apply();
        });
    }

     public applySearch = () => {
         if (!this.validateFilter()) {
             return;
         }

         this.canLoadMore = true;
         this.items = [];
         this.total = 0;
         this.loadData();
    }

    public toggleFilter = () => {
        this.filter.toggle();
    }

    public applyFilter = (newFilterSetting: any) => {
        newFilterSetting.stickerType = +newFilterSetting.stickerType;
        this.filter.set(newFilterSetting);
        this.applySearch();
    }

    public clearFilter = () => {
        if (this.filter.isApplied) {
            this.filter.clear();
            this.applySearch();
        } else {
            this.filter.clear();
        }
    }

     public loadData = () =>  {
        if (this.waiting || !this.canLoadMore) {
            return;
        }
        this.waiting = true;

        const lastItem = _.last(this.items);
        const lastStickerNumber = lastItem ? lastItem.ID : undefined;

        const filter: NfcStickerRequest = {
            SearchAfterStickerID: lastStickerNumber,
            SearchTerm: this.search.text,
            Limit: this.itemsLimit
        };

        if (this.filter.isActive) {
            filter.NfcStickerType =  this.filter.data.type === 0 ? null : this.filter.data.type as NfcStickerTypeEnum;
            filter.PlaceIDs = this.filter.data.selectedLocations.map((x) => x.ID);
            filter.DateFrom = this.filter.data.dateFrom ? moment(this.filter.data.dateFrom).startOf('day').toDate() : null;
            filter.DateTo = this.filter.data.dateTo ? moment(this.filter.data.dateTo).endOf('day').toDate() : null;
        }

        this.notificationService.showWaitingMessage();

        this.nfcRetailerStickersService.getFreeStickersCount()
            .then((response) => {
                this.freeStickersCount = response;
            })
            .catch((error) => {
                this.notificationService.showErrorMessage(error);
            });

        return this.nfcRetailerStickersService.getActiveStickers(filter)
            .then((response) => {
                this.total = response.Total;
                Array.prototype.push.apply(this.items, response.Items);
                if (this.items.length === 0) {
                    this.setEmptyMessage(filter);
                }
                this.canLoadMore = response.Items.length === this.itemsLimit;
            })
            .catch((error) => {
                this.notificationService.showErrorMessage(error);
            })
            .finally(() => {
                this.waiting = false;
                this.notificationService.clearAll();
            });
    }

    private validateFilter(): boolean {
        const dateFrom = this.filter.data.dateFrom;
        const dateTo = this.filter.data.dateTo;

        if (!dateFrom && !dateTo) {
            return true;
        }

        if (!dateFrom) {
            this.notificationService.showErrorMessage(this.$translate.instant('date_from_is_requierd_error'));
            return false;
        }

        if (!dateTo) {
            this.notificationService.showErrorMessage(this.$translate.instant('date_to_is_required_error'));
            return false;
        }

        const datesDiff = moment(dateTo).diff(dateFrom, 'seconds');
        if (datesDiff < 0) {
            this.notificationService.showErrorMessage(this.$translate.instant('invalid_date_range_error'));
            return false;
        }

        return true;
    }

    private setEmptyMessage = (filter: NfcStickerRequest) => {
        this.emptyStickerMessageTitle = this.$translate.instant('nfc_active_tab_empty_such_stickers_message_title');
        this.emptyStickerMessage = this.$translate.instant('nfc_active_tab_empty_such_stickers_message');
    }
}

angular.module('naut').component('nfcRetailerActiveTab', {
    template: require('./nfc-retailer-active-tab.component.html'),
    controller: NfcRetailerActiveTab,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/active-tab/nfc-retailer-active-tab.component.ts